<app-dialog-base [Title]='"Service task"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <ng-container *ngIf="model">
    <div class="inputgroup">
      <label>{{'Object'|translate }}</label>
      <input type="text" [ngModel]="model.ObjectName" disabled />
    </div>
    <div class="inputgroup">
      <label>{{'Name'|translate }}</label>
      <input type="text" [(ngModel)]="model.Name" />
    </div>
    <div class="inputgroup inputgroupwithtextarea">
      <label>{{'Description'|translate }}</label>
      <textarea rows="5" [(ngModel)]="model.Comment"></textarea>
    </div>

    <div class="inputgroup inputgroupcomplex">
      <span>
      </span>
      <div>
        <label>{{'First execution'|translate }}</label>
        <label>
          <label>{{'Repeat'|translate }}</label>
        </label>
      </div>
    </div>

    <div class="inputgroup inputgroupcomplex">
      <span>
        <input type="checkbox" [(ngModel)]="model.TimeEnabled" />
        <label>{{'Date'|translate }}</label>
      </span>
      <div>
        <calendar [name]="'Time'" [(date)]="model.Time" [disabled]="!model.TimeEnabled"></calendar>
        <label>
          <input type="number" [ngModel]="model.TimePeriod | localizeDays" (ngModelChange)="convertTimePeriod($event)" [attr.disabled]="!model.TimeEnabled || null" />
          <span>{{'days'|translate}}</span>
        </label>
      </div>
    </div>
    <div class="inputgroup inputgroupcomplex">
      <span>
        <input type="checkbox" [(ngModel)]="model.OdometrEnabled" />
        <label>{{'Odometer'|translate }}</label>
      </span>
      <div>
        <label>
          <input type="text" [ngModel]="model.Odometr | localizeKMeters" (ngModelChange)="convertOdometr($event)" [attr.disabled]="!model.OdometrEnabled || null" />
          <span>{{'km'|localizeUnits}}</span>
        </label>
        <label>
          <input type="text" [ngModel]="model.OdometrPeriod | localizeKMeters" (ngModelChange)="convertOdometrPeriod($event)" [attr.disabled]="!model.OdometrEnabled || null" />
          <span>{{'km'|localizeUnits}}</span>
        </label>
      </div>
    </div>
    <div class="inputgroup inputgroupcomplex">
      <span>
        <input type="checkbox" [(ngModel)]="model.WorkTimeEnabled" />
        <label>{{'Engine time'|translate }}</label>
      </span>
      <div>
        <label>
          <input type="number" [ngModel]="model.WorkTime | localizeHours" (ngModelChange)="convertEngineTime($event)" [attr.disabled]="!model.WorkTimeEnabled || null" />
          <span>{{'h'|translate}}</span>
        </label>
        <label>
          <input type="number" [ngModel]="model.WorkTimePeriod | localizeHours" (ngModelChange)="convertEngineTimePeriod($event)" [attr.disabled]="!model.WorkTimeEnabled || null" />
          <span>{{'h'|translate}}</span>
        </label>
      </div>
    </div>
  </ng-container>
</app-dialog-base>
